import { render, staticRenderFns } from "./AreaRegionCatalogForm.vue?vue&type=template&id=6d64cfec&"
import script from "./AreaRegionCatalogForm.vue?vue&type=script&lang=js&"
export * from "./AreaRegionCatalogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports